// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3ks_5","imageUploader":"EGiftCard_imageUploader__1K3y-"};